(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-product-info-button-text"] && !Shopify.designMode) return;
  try {
    (function() {
    function updateButtonText() {
      if (window.innerWidth <= 749) {
        const section = document.querySelector('.section[data-testid="ui-test-section"]');
        if (!section) return;
        
        const buttons = section.querySelectorAll('button, a.button');
        
        buttons.forEach(function(button) {
          const text = button.textContent.trim();
          
          if (text === 'Shop Glow Sunscreen') {
            button.textContent = 'Shop Sunscreen';
          } else if (text === 'Shop Cloud Moisturizer') {
            button.textContent = 'Shop Moisturizer';
          } else if (text === 'Shop Balance Cleanser') {
            button.textContent = 'Shop Cleanser';
          }
        });
      } else {
        const section = document.querySelector('.section[data-testid="ui-test-section"]');
        if (!section) return;
        
        const buttons = section.querySelectorAll('button, a.button');
        
        buttons.forEach(function(button) {
          const text = button.textContent.trim();
          
          if (text === 'Shop Sunscreen') {
            button.textContent = 'Shop Glow Sunscreen';
          } else if (text === 'Shop Moisturizer') {
            button.textContent = 'Shop Cloud Moisturizer';
          } else if (text === 'Shop Cleanser') {
            button.textContent = 'Shop Balance Cleanser';
          }
        });
      }
    }
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateButtonText);
    } else {
      updateButtonText();
    }
    
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateButtonText, 250);
    });
    
    const observer = new MutationObserver(function(mutations) {
      updateButtonText();
    });
    
    if (document.body) {
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
